import React from 'react';

import { MdmDeviceDto, useCreateDeviceMutation } from 'gql/generated/types';
import { useNavigate, useParams } from 'react-router-dom';
import { T } from 'services/lang/LanguageService';
import DeviceForm from '../components/DeviceForm';
import { errorToaster, successToaster } from '../utils/utils';

const NewDeviceForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [createDeviceMutation, { loading }] = useCreateDeviceMutation({
    onCompleted: () => {
      successToaster(T("alert.device-created-successfully"));
      navigate(`/mdm/${projectId}/devices`);
    },
    onError: errorToaster,
  });

  const handleCreate = (device: Partial<MdmDeviceDto>) => {
    const { objectRelation, project, ...restDevice } = device
    createDeviceMutation({
      variables: { device: { ...restDevice, roleInObject: objectRelation?.roleInObject }, objectId: device.objectRelation?.mdmObject?.id! },
    });
  };
  
  return <DeviceForm device={null} onSubmit={handleCreate} newForm loading={loading} />;
}

export default NewDeviceForm